export default "__VITE_ASSET__b7e2fe7f__"